import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentTypeCodeDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-documenttypecode',
  templateUrl: './documenttypecode.component.html',
  styleUrls: ['./documenttypecode.component.scss']
})
export class DocumentTypeCodeComponent implements OnChanges {


  documenttypecodeForm: FormGroup;
  documenttypecodeFormArray: FormGroup;
  control = new FormControl();
  @Input() documenttypecodes: DocumentTypeCodeDto[];
  @Input() routeAnimationsElements: any;
  @Output() documenttypecode = new EventEmitter<DocumentTypeCodeDto[]>()
  @Output() deleteDocumentTypeCodeEvent = new EventEmitter<any>()

    selectedDocumentTypeCode: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createDocumentTypeCodeForm();
    }

    createDocumentTypeCodeForm() {
      this.documenttypecodeForm = this.fb.group({
        DocumentTypeCodeName: ['', Validators.required],
        DocumentTypeCodeMainName: ['',Validators.required],
        id: null
        });
        this.documenttypecodeFormArray = this.fb.group({ DocumentTypeCodes: this.fb.array([])
          });
        this.setDocumentTypeCode();
    }

  // method to display documenttypecodes
  setDocumentTypeCode() {
    const control  = this.documenttypecodeFormArray.controls.DocumentTypeCodes as FormArray;
    this.documenttypecodes.forEach( e => {
      control.push(
        this.fb.group({
          DocumentTypeCodeName: e.DocumentTypeCodeName,
          DocumentTypeCodeMainName: e.DocumentTypeCodeMainName,
          id: e.id
        })
      );
    });
  }


  // method to add DocumentTypeCode
  addDocumentTypeCode(value: DocumentTypeCodeDto) {
    const control  = this.documenttypecodeFormArray.controls.DocumentTypeCodes as FormArray;
    control.insert(0,
          this.fb.group({
            DocumentTypeCodeName: value.DocumentTypeCodeName,
            DocumentTypeCodeMainName: value.DocumentTypeCodeMainName,
            id: null
          })
       );
  }

  selectDocumentTypeCode(value) {}

  // method to delete documenttypecode from arrary list
  deleteDocumentTypeCode(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.documenttypecodeFormArray.controls.DocumentTypeCodes as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.documenttypecodes.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.documenttypecodes[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: DocumentTypeCodeDto) {
    if(this.documenttypecodeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.documenttypecodeFormArray.get('DocumentTypeCodes')['controls'][this.selectedIndex].patchValue({DocumentTypeCodeName: formValue.DocumentTypeCodeName, DocumentTypeCodeMainName:formValue.DocumentTypeCodeMainName});
    } else {
      this.addDocumentTypeCode(formValue);
    }
    this.selectedIndex = null;
    this.documenttypecodeForm.reset()
  }

  onEdit(index, value: DocumentTypeCodeDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.documenttypecodeForm.patchValue({DocumentTypeCodeName: value.DocumentTypeCodeName, DocumentTypeCodeMainName: value.DocumentTypeCodeMainName });
    //this.documenttypecodeForm.patchValue({DocumentTypeCodeMainName: value.DocumentTypeCodeMainName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.documenttypecodeForm.reset();
  }

  onSubmit(formValue: DocumentTypeCodeDto[]) {
  this.documenttypecode.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteDocumentTypeCodeEvent.emit(this.filteredDelete);
  }
  }

}
